import { lazy } from "react";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import AuthenticationRequired from "@/components/auth/AuthenticationRequired";

const StaffManagement = lazy(() => import("@/pages/staff/StaffManagement"));
const UserDashboard = lazy(() => import("@/pages/UserDashboard"));

const PatientAssessment = lazy(() => import("@/pages/enterprise/PatientAssessment"));
const CarePlanning = lazy(() => import("@/pages/enterprise/CarePlanning"));
const ProgressTracking = lazy(() => import("@/pages/assessment/ProgressTracking"));
const RachelAI = lazy(() => import("@/pages/RachelAI"));
const AssessmentSessionPage = lazy(() => import("@/pages/assessment/[sessionId]"));

export const privateRoutes = [
  {
    path: "/staff",
    element: (
      <ProtectedRoute allowedRoles={["provider"]}>
        <StaffManagement />
      </ProtectedRoute>
    ),
  },
  
  {
    path: "/portal/provider/assessment",
    element: (
      <ProtectedRoute allowedRoles={["provider"]}>
        <PatientAssessment />
      </ProtectedRoute>
    ),
  },
  {
    path: "/portal/provider/care-planning",
    element: (
      <ProtectedRoute allowedRoles={["provider"]}>
        <CarePlanning />
      </ProtectedRoute>
    ),
  },
  {
    path: "/portal/provider/progress",
    element: (
      <ProtectedRoute allowedRoles={["provider"]}>
        <ProgressTracking />
      </ProtectedRoute>
    ),
  },

  {
    path: "/portal/rachel-ai",
    element: (
      <ProtectedRoute allowedRoles={["patient", "caregiver"]}>
        <RachelAI />
      </ProtectedRoute>
    ),
  },
  {
    path: "/assessment/session/:sessionId",
    element: (
      <ProtectedRoute allowedRoles={["patient", "provider"]}>
        <AssessmentSessionPage />
      </ProtectedRoute>
    ),
    errorElement: (
      <AuthenticationRequired 
        message="Please log in to access the assessment session"
        returnPath="/assessment"
      />
    ),
  },
  {
    path: '/rachel',
    element: (
      <ProtectedRoute>
        <RachelAI />
      </ProtectedRoute>
    ),
    errorElement: (
      <AuthenticationRequired 
        message="Please log in to chat with Gia"
        returnPath="/rachel"
      />
    ),
  },
];